import { render, staticRenderFns } from "./batchEdit.vue?vue&type=template&id=add1e018&"
import script from "./batchEdit.vue?vue&type=script&lang=js&"
export * from "./batchEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports